import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeBox20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCodeBox20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 4.5h13a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1M1 5.5A2.5 2.5 0 0 1 3.5 3h13A2.5 2.5 0 0 1 19 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 14.5zm6.415 2.583a.75.75 0 0 0-1.06-1.061L3.906 9.47l-.53.53.53.53 2.447 2.448a.75.75 0 1 0 1.06-1.06L5.499 10zm5.17 0a.75.75 0 1 1 1.06-1.061l2.448 2.448.53.53-.53.53-2.447 2.448a.75.75 0 0 1-1.061-1.06L14.502 10zM11.232 6.95a.75.75 0 0 1 .432.97l-1.82 4.74a.75.75 0 1 1-1.4-.538l1.82-4.74a.75.75 0 0 1 .968-.432"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeBox20);
